import networkService from '../Network/NetworkManager';
import {uuid} from 'uuidv4';

export const switchTenant = async tenant_id => {
  const responseJson = await networkService.networkCall(
    `skua/users/switch_tenant`,
    'post',
    JSON.stringify({uuid: uuid(), tenant_id: tenant_id}),
    '',
    '',
  );

  // networkCall returns a string for API errors (and an Error for transport
  // failures). Do not assume every response has the successful data shape.
  if (!responseJson || typeof responseJson !== 'object') {
    return {
      error:
        responseJson?.message ||
        (typeof responseJson === 'string' ? responseJson : 'Unable to switch tenant.'),
    };
  }

  const user = responseJson?.data?.user;
  if (!user) {
    return {
      error:
        responseJson?.error?.message ||
        responseJson?.message ||
        'Unable to switch tenant.',
    };
  }

  return user;
};
